import React from 'react'

import crs from '../../assests/images/partners/crs.png'
import homeserve from '../../assests/images/partners/homeserve-real.png'
import homeserveHover from '../../assests/images/partners/homeserve-real-hover.png'
// import mlspin from '../../assests/images/partners/mlspin.png'
import realtyna from '../../assests/images/partners/realtyna.png'
// import smartmls from '../../assests/images/partners/smartmls.png'
import stripe from '../../assests/images/partners/stripe.png'
import { useTranslation } from 'react-i18next'


const Partners = () => {
    const { t } = useTranslation()
    const [homeserveHovered, setHomeserveHovered] = React.useState(false)
    const featureImage = [
        { img: crs },
        { img: homeserve, hoverImg: homeserveHover },
        // { img: mlspin },
        { img: realtyna },
        // { img: smartmls },
        { img: stripe },
    ]
    return (
        <>
            <div className='py-10 bg-gray-100'>
                <div className='container mx-auto'>
                    <h2 className='text-center text-[2.5rem] font-bold p-0'>{t('partners')}</h2>
                    <div className='flex justify-center items-center'>
                        <div className="grid lg:grid-cols-4 grid-cols-2 gap-20 items-center mt-4">
                            {
                                featureImage.map((list, i) => (
                                    <div
                                        className='p-5'
                                        key={i}
                                        onMouseEnter={list.hoverImg ? () => setHomeserveHovered(true) : undefined}
                                        onMouseLeave={list.hoverImg ? () => setHomeserveHovered(false) : undefined}
                                    >
                                        <img
                                            src={list.hoverImg && homeserveHovered ? list.hoverImg : list.img}
                                            className={`object-cover w-[100%] transition duration-300 ${list.hoverImg ? (homeserveHovered ? '' : 'grayscale') : 'grayscale hover:grayscale-0'}`}
                                            alt="feature_image"
                                        />
                                    </div>
                                ))
                            }
                            
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Partners